module.exports = __webpack_public_path__ + "static/media/19ESCAP32.8f242864.jpg";